import { render, staticRenderFns } from "./MessagesLayout.vue?vue&type=template&id=3b3dc1c8"
import script from "./MessagesLayout.vue?vue&type=script&lang=js"
export * from "./MessagesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports